import { type VoidComponent } from "solid-js";
import { useTranslation } from "../../../../../state/i18n";
import SettingSection from "../../components/SettingSection";
import { TextAndIconButton } from "../../../../../components/button/Button.tsx";

// TODO: DEV-8322 + DEV-8323
const PaymentMethodSection: VoidComponent = () => {
  const { t } = useTranslation();

  return (
    <SettingSection
      ariaIdPrefix="payment"
      title={t(($) => $.SETTINGS_BILLING_PAYMENT_METHOD_TITLE)}
      description={t(($) => $.SETTINGS_BILLING_PAYMENT_METHOD_DESCRIPTION)}
    >
      <TextAndIconButton
        class="ml-auto"
        variant="light"
        icon="plus"
        text={t(($) => $.SETTINGS_BILLING_PAYMENT_METHOD_ADD_LABEL)}
      />
    </SettingSection>
  );
};

export default PaymentMethodSection;
